const hasOwn = {}.hasOwnProperty

export default function classNames() {
  const theme = arguments[0]
  const args = Array.prototype.slice.call(arguments, 1)
  const classes = []
  let i = args.length - 1

  if (i === 0 && typeof args[0] === 'string') {
    return theme[args[0]]
  }

  for (; i >= 0; i--) {
    const arg = args[i]
    if (!arg) continue

    const argType = typeof arg

    if (argType === 'string' || argType === 'number') {
      classes.push(theme[arg])
    } else if (Array.isArray(arg)) {
      classes.push(classNames(theme, ...arg))
    } else if (argType === 'object') {
      for (const key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes.push(theme[key])
        }
      }
    }
  }

  return classes.join(' ')
}



// WEBPACK FOOTER //
// ./helpers/classNames.js